import { createFileRoute } from "@tanstack/react-router";
import { AiStudioHome } from "@/components/AiStudio";

export const Route = createFileRoute("/_authenticated/ai-studio/")({
  component: AiStudioHome,
  staticData: { page: "university" },
});
